import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

import { useHistory } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Alert,
  Button,
  FormGroup,
  Card,
  CardBody,
  CardTitle,
} from "reactstrap";

import { Table, Thead, Tbody, Tr, Th } from "react-super-responsive-table";
import { getOnboarder, postOnboarder } from "../../../api/common";
import { showLoader, removeLoader } from "../../../store/Loader/actions";
import PaymentLine from "./PaymentLine";
import {
  setNextStep,
  nextState,
  previousState,
  saveActiveCompany,
} from "../../../store/CompanyState/actions";
import ActionFooter from "../ActionFooter";
import ActionHeader from "../ActionHeader";
import { handleErrorsAllMessage, formatDate } from "../../../utils";
import debounce from "lodash.debounce";
import TotalLines from "../../TotalLines";

const PaymentMethods = ({
  setNextStep,
  nextState,
  previousState,
  saveActiveCompany,
  company,
  activeCompanyIsEditable,
  showLoader,
  removeLoader,
}) => {
  let history = useHistory();
  const [canSave, setCanSave] = useState(false);
  const [errors, setErrors] = useState([]);
  const [lines, setLines] = useState([]);
  const [deleteLines, setDeleteLines] = useState([]);
  const [deleted, setDeleted] = useState([]);
  const [banks, setBanks] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [users, setUsers] = useState([]);
  const [totalBalance, setTotalBalance] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const form = useRef([]);

  const onValidSubmit = (e, vals) => {};
  const deleteLine = (id) => {
    setDeleted((deleted) => [...deleted, id]);
  };

  let save = debounce(() => {
    savePaymentMethods(() => {
      setNextStep(null);
      saveActiveCompany();
    });
  }, 200);
  const saveExit = debounce(() => {
    savePaymentMethods(() => {
      setNextStep("exit");
      history.goBack();
    });
  }, 200);
  const next = debounce(() => {
    savePaymentMethods(() => {
      setNextStep("next");
      nextState();
    });
  }, 200);
  const back = debounce(() => {
    savePaymentMethods(() => {
      setNextStep("back");
      previousState();
    });
  }, 200);
  const getBanks = () => {
    getOnboarder(`/OnboardingBase/bank/`).then((data) => {
      if (activeCompanyIsEditable)
        setBanks(data.filter((line) => line?.erp_id && line?.is_active));
      else {
        setBanks(data);
      }
    });
  };
  const getAccounts = () => {
    getOnboarder(`/UserManagement/${company?.id}/accounts`).then((data) => {
      setAccounts(data);
    });
  };
  const getEmployees = () => {
    getOnboarder(`/UserManagement/${company?.id}/employee`).then((data) => {
      setUsers(data);
    });
  };
  useEffect(() => {
    showLoader();
    getOnboarder(`/UserManagement/${company?.id}/payment-method/`)
      .then((data) => {
        data.forEach((line) => {
          line.updated = false;
          line.selected = false;
        });
        setLines(data);
        removeLoader();
      })
      .catch(() => {
        removeLoader();
      });

    getBanks();
    getAccounts();
    getEmployees();
    setCanSave(true);
  }, []);
  let savePaymentMethods = (cb) => {
    const body = {
      payment_methods: lines.filter((line) => line.updated),
      delete: deleteLines || [],
    };
    if (body.payment_methods.length || body.delete.length) {
      setCanSave(false);
      showLoader();
      postOnboarder(
        `/UserManagement/${company?.id}/payment-method/submit`,
        body
      )
        .then((data) => {
          setErrors({});
          data.forEach((line) => {
            line.updated = false;
            line.selected = false;
          });
          setLines(data);
          cb();
          setCanSave(true);
          removeLoader();
        })
        .catch((error) => {
          setErrors(error);
          removeLoader();
          setCanSave(true);
          throw error;
        });
    } else {
      setErrors({});
      cb();
    }
  };

  useEffect(() => {
    if (form.current) {
      form.current.setTouched(Object.keys(form.current._inputs));
      const values = form.current.getValues();
      form.current.validateAll(values).then((errors) => {
        if (form.current) {
          setCanSave(!form.current.hasError());
        }
      });
    }

    let sumOfLines = lines
      .filter((line) => line.payment_method !== "credit_card")
      .reduce((sum, line) => sum + parseFloat(line.balance), 0);

    let sumOfDebit = lines
      .filter(
        (line) => line.payment_method === "credit_card" && line.balance <= 0
      )
      .reduce((sum, line) => sum + parseFloat(line.balance), 0);
    let sumOfCredit = lines
      .filter(
        (line) => line.payment_method === "credit_card" && line.balance > 0
      )
      .reduce((sum, line) => sum + parseFloat(line.balance), 0);
    setTotalBalance((sumOfLines + Math.abs(sumOfDebit) || 0.0).toFixed(2));
    setTotalCredit((sumOfCredit || 0.0).toFixed(2));
  }, [lines]);

  useEffect(() => {
    const div = document.querySelector(".alert-danger");
    div?.scrollIntoView({ behavior: "auto", block: "center" });
  }, [errors]);
  const handleAddNew = () => {
    setLines((lines) => [
      ...lines,
      { updated: true, selected: false, payment_method: "bank" },
    ]);
  };
  const deleteRows = debounce(() => {
    setLines((lines) => lines.filter((line) => !line.selected));
    setDeleteLines(
      lines.filter((line) => line.selected).map((line) => line.id)
    );
  }, 200);
  const toggleSelectAll = (e) => {
    const checked = e.target.checked;
    let items = [...lines];
    items.forEach((item) => {
      item.selected = checked;
    });
    setLines(items);
  };
  return (
    <div className="container-fluid">
      <ActionHeader
        canSave={canSave}
        save={save}
        deleteRows={deleteRows}
        lines={lines}
        saveExit={saveExit}
      />
      <Card style={{ marginBottom: "0rem" }}>
        <CardBody style={{ padding: "0.75rem", paddingBottom: "0rem" }}>
          <Row>
            <CardTitle>
              Payment Method As of: {formatDate(company.starting_date)}
            </CardTitle>
          </Row>
          <Col>
            {handleErrorsAllMessage(errors) && (
              <Alert color="danger">{handleErrorsAllMessage(errors)}</Alert>
            )}
          </Col>

          <AvForm
            className="needs-validation"
            ref={form}
            onValidSubmit={onValidSubmit}
          >
            <div className="table-container-input">
              <Table className="table-responsive-input">
                <Thead>
                  <Tr>
                    <Th style={{ minWidth: "10px" }}>
                      <FormGroup>
                        <AvField
                          type="checkbox"
                          name="selected"
                          onChange={toggleSelectAll}
                          disabled={!activeCompanyIsEditable}
                        />
                      </FormGroup>
                    </Th>
                    <Th style={{ minWidth: "200px" }}>Payment Method</Th>
                    <Th style={{ minWidth: "220px" }}>Partner</Th>
                    <Th>Account Number</Th>
                    <Th>
                      Balance
                      <br /> ( as of {formatDate(company.starting_date)})
                    </Th>
                    <Th>
                      Staff User
                      <br /> (Payment Owner)
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {lines.map((paymentMethod, index) => {
                    return (
                      <PaymentLine
                        index={index}
                        line={paymentMethod}
                        users={users}
                        banks={banks}
                        accounts={accounts}
                        setAccounts={setAccounts}
                        setLines={setLines}
                        deleteLine={deleteLine}
                        lines={lines}
                        setCanSave={setCanSave}
                        company={company}
                      />
                    );
                  })}
                </Tbody>
              </Table>
            </div>
            {activeCompanyIsEditable && (
              <Button color="link" onClick={handleAddNew}>
                Add New Line
              </Button>
            )}
          </AvForm>

          <Row>
            <Col md="6">
              <TotalLines
                title={"Total Company Payment Methods Balance"}
                total={totalBalance}
              />
            </Col>

            <Col md="6">
              <TotalLines
                title={"Total Company Credit Balance"}
                total={totalCredit}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <ActionFooter
        next={next}
        canSave={canSave}
        back={back}
        complete={savePaymentMethods}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    company: state.CompanyState.activeCompany,
    activeCompanyIsEditable: state.CompanyState.activeCompanyIsEditable,
  };
};
export default connect(mapStateToProps, {
  setNextStep,
  nextState,
  previousState,
  saveActiveCompany,
  showLoader,
  removeLoader,
})(PaymentMethods);
